import React from "react";
import { Container, Paper } from "@material-ui/core";
import HcSummary from "../components/HcSummary";

export default function HcSummaryPage() {
  return (
    <Container maxWidth="md">
      <Paper>
        <HcSummary />
      </Paper>
    </Container>
  );
}
